import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { usePlmEventResponseByIdQuery } from '../../../../types/generated-types';
import { Notifier } from '../../../system/services/notificationManager';

export const PlmEventResponseExternalLink: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get query parameters
  const responseId = searchParams.get('responseId');
  const eventId = searchParams.get('eventId');
  const contractId = searchParams.get('contractId');

  console.log(
    'PLM Event Response External Link',
    responseId,
    eventId,
    contractId,
  );
  // const contractId = searchParams.get('contractId');

  // Query for PLM Event Response by ID if responseId is provided
  const { data, loading, error } = usePlmEventResponseByIdQuery({
    variables: { _id: responseId! },
    skip: !responseId,
  });

  useEffect(() => {
    if (loading) {
      return; // Still loading, wait
    }

    if (error) {
      Notifier.error('Failed to load PLM Event Response');
      navigate('/plm-event-responses');
      return;
    }

    if (responseId && data?.plmEventResponseById) {
      // Found the response, redirect to edit screen
      navigate(`/plm-event-responses/${responseId}/edit`, { replace: true });
      return;
    }

    // If we have eventId or contractId but no responseId, we need to find the response
    if (eventId || contractId) {
      // For now, redirect to the list view where they can search
      // In the future, we could implement a more sophisticated search
      navigate('/plm-event-responses', { replace: true });
      return;
    }

    // No valid parameters provided
    Notifier.error(
      'Invalid link parameters. Please check the link and try again.',
    );
    navigate('/plm-event-responses', { replace: true });
  }, [responseId, eventId, contractId, data, loading, error, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
      p={3}
    >
      <Box sx={{ marginBottom: '2rem' }}>
        <CircularProgress color="secondary" size="3rem" />
      </Box>
      <Box>
        <Typography variant="h6" color="text.secondary">
          Loading PLM Event Response...
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Please wait while we redirect you to the appropriate screen.
        </Typography>
      </Box>
    </Box>
  );
};
